import BerechtigteListService from "./BerechtigteListService";

class DisjunctiveListError extends Error {}

/**
 * Ist ein Filter sowohl in der URL als auch in den QueryParams enthalten,
 * werden beim Standard-ListService alle Werte des Filters übernommen.
 * Beim ConjunctiveListService hingegen wird die Schnittmenge verwendet; wodurch
 * es möglich wird, durch QueryParams die Standardwerte weiter einzugrenzen.
 */
export default class ConjunctiveListService extends BerechtigteListService {

  async list(queryParams) {
    try {
      return super.list(queryParams);
    } catch (e) {
      if (e instanceof DisjunctiveListError) {
        return {totalCount: 0, json: []}
      }
      throw e
    }
  }

  requestUrl(queryParams) {
    if (queryParams) {
      const url = new URL(this.url)
      const urlSearchParams = new URLSearchParams()
      Object.entries(queryParams).forEach(([key, value]) => {
        this.appendQueryParams(urlSearchParams, key, value)
      })
      new Set(url.searchParams.keys()).forEach(key => {
        this.appendSearchParams(urlSearchParams, key, url.searchParams.getAll(key))
      })
      return `${url.origin}${url.pathname}?${urlSearchParams.toString()}`
    } else {
      return this.url
    }
  }

  appendSearchParams(urlSearchParams, key, values) {
    if (urlSearchParams.has(key)) {
      urlSearchParams.getAll(key)
        .filter(value => !values.includes(value))
        .forEach(value => urlSearchParams.delete(key, value))
      if (!urlSearchParams.has(key)) {
        // QueryParams und SearchParams sind disjunkt -> Immer leeres Ergebnis
        throw new DisjunctiveListError()
      }
    } else {
      this.appendQueryParams(urlSearchParams, key, values)
    }
  }
}
